export enum WritebackSetupStep {
  WELCOME,
  SELECT_DESTINATION,
  REVIEW,
}
